import React from 'react';
import styled from 'styled-components';

const StyledBanner = styled.section`
	background: ${({ url }) => `url(${url}) no-repeat, #bacdec`};
	background-position: ${({ backgroudPosition }) => `${backgroudPosition}`};
	margin-bottom: ${({ marginBottom }) => `${marginBottom || 20}px`};
	min-height: 375px;
	@media screen and (max-width: 767px) {
		margin-bottom: ${({ marginBottom }) => `${marginBottom || 20}px`};
	}
`;
const Banner = ({
	brandDetails,
	url,
	marginBottom,
	backgroudPosition = 'right'
}) => {
	return (
		<StyledBanner
			tag={brandDetails.tag}
			url={url}
			marginBottom={marginBottom}
			backgroudPosition={backgroudPosition}
		>
			<div></div>
		</StyledBanner>
	);
};

export default Banner;
